import type { ButtonRowBlock } from "./types";

export function buttonRowExpandsHorizontally(block: ButtonRowBlock): boolean {
  return block.buttons.some(slot => slot.fullWidth);
}

export function buttonRowCellWidth(
  block: ButtonRowBlock,
  index: number,
): string | undefined {
  const fills = block.buttons.map(slot => slot.fullWidth);
  if (fills.every(Boolean)) {
    return `${100 / fills.length}%`;
  }
  if (!fills.some(Boolean)) {
    return undefined;
  }
  return fills[index] ? '100%' : undefined;
}

export function buttonRowSlotFillsHorizontally(
  block: ButtonRowBlock,
  index: number,
): boolean {
  return block.buttons[index]?.fullWidth ?? false;
}
